<ion-modal
  class="inq-decline-modal"
  [isOpen]="context() !== null"
  [backdropDismiss]="!busy()"
  (didDismiss)="close()">
  <ng-template>
    @if (context(); as ctx) {
      <div class="inqd">
        <div class="inqd__header">
          <div class="inqd__titles">
            <tidy-text [header]="'Decline inquiry'" />
            <span class="inqd__subtitle">{{ ctx.subtitle }}</span>
          </div>
          <button
            type="button"
            class="inqd__close"
            aria-label="Close"
            [disabled]="busy()"
            (click)="close()">
            <tidy-image [src]="'assets/svg/close.svg'" class="inqd__close-icon" />
          </button>
        </div>

        <div class="inqd__context">
          <div class="inqd__avatar">{{ ctx.initials }}</div>
          <div class="inqd__context-meta">
            <span class="inqd__context-name">{{ ctx.guestName }}</span>
            <span class="inqd__context-sub">{{ ctx.dateRange }} · {{ ctx.propertyLine }}</span>
          </div>
          <span class="inqd__source-pill">{{ ctx.sourceName }}</span>
        </div>

        <div class="inqd__body">
          @if (ctx.isTidy) {
            <div class="inqd__note">
              <div class="inqd__note-head">
                <span class="inqd__note-label">Reason (optional, shared with the guest)</span>
              </div>
              <span class="inqd__note-helper">
                Included in the decline email the guest receives.
              </span>
              <textarea
                class="inqd__textarea"
                rows="3"
                [value]="note()"
                [disabled]="busy()"
                [placeholder]="'Tell the guest why (optional)…' | translate"
                (input)="onNoteInput($event)"></textarea>
            </div>
          } @else {
          <div class="inqd__reasons" role="radiogroup" aria-label="Decline reason">
            @for (reasonOption of ctx.reasons; track reasonOption.value) {
              <button
                type="button"
                class="inqd__reason"
                role="radio"
                [attr.aria-checked]="reason()?.value === reasonOption.value"
                [class.inqd__reason--selected]="reason()?.value === reasonOption.value"
                [disabled]="busy()"
                (click)="selectReason(reasonOption)">
                <span class="inqd__radio"></span>
                <span class="inqd__reason-label">{{ reasonOption.label }}</span>
                @if (reasonOption.notesAirbnb) {
                  <span class="inqd__reason-tag">Note required</span>
                }
              </button>
            }
          </div>

          @if (reason(); as selectedReason) {
            <div class="inqd__note">
              <div class="inqd__note-head">
                <span class="inqd__note-label">
                  {{ selectedReason.notesAirbnb ? 'Note to ' + ctx.sourceName : 'Message to guest' }}
                </span>
                <span class="inqd__note-flag">Required</span>
              </div>
              <span class="inqd__note-helper">
                {{ selectedReason.notesAirbnb
                    ? 'Only ' + ctx.sourceName + ' sees this — it is never shown to the guest.'
                    : 'Delivered to the guest as a chat message.' }}
              </span>
              <textarea
                class="inqd__textarea"
                rows="3"
                [value]="note()"
                [disabled]="busy()"
                [placeholder]="selectedReason.notesAirbnb ? ('Tell ' | translate) + (ctx.sourceName | translate) + (' more…' | translate) : ('Write a message for the guest…' | translate)"
                (input)="onNoteInput($event)"></textarea>
              @if (selectedReason.notesAirbnb) {
                <div class="inqd__meter" [class.inqd__meter--met]="noteMet()">
                  <div class="inqd__meter-track">
                    <div class="inqd__meter-fill" [style.width.%]="noteProgress()"></div>
                  </div>
                  <span class="inqd__meter-hint">{{ noteHint() }}</span>
                  <span class="inqd__meter-count">{{ noteCount() }}/{{ noteMinLength }}</span>
                </div>
              }
            </div>
          }
        }
        </div>

        <div class="inqd__footer">
          <tidy-small-button
            [text]="'Cancel'"
            [disabled]="busy()"
            (buttonClick)="close()" />
          <tidy-small-button
            [text]="busy() ? 'Declining…' : 'Decline inquiry'"
            [danger]="true"
            [disabled]="!canSubmit()"
            (buttonClick)="submit()" />
        </div>
      </div>
    }
  </ng-template>
</ion-modal>
